import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Filterable } from '@common/utilities/Filterable';
import { PaymentReport, PaymentType } from '@core/services/data.service';
import { GroupsService } from '@core/services/groups.service';
import { PartnersService } from '@core/services/partners.service';
import { ServicesService } from '@core/services/services.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { Multilingual } from '@core/utilities/multilingual';

@Component({
  templateUrl: './payment-reports-viewer.component.html',
  styleUrls: ['./payment-reports-viewer.component.scss']
})
export class PaymentReportsViewerComponent implements OnInit {

  @Input()
  public title: string;

  @Input()
  public reports: PaymentReport[];

  public payments = new Filterable<PaymentReport>({
    extractor: i => [this.date.transform(i.Stamp, 'dd-MM-yyyy') + ' ' + this.name(i)],
    grouper: i => [
      { name: 'Theo ngày', option: this.date.transform(i.Stamp, 'dd-MM-yyyy') },
      { name: i.Type == PaymentType.Partner ? 'Theo đối tác' : 'Theo nhóm', option: i.Type == PaymentType.Partner ? this.name(i) : this.group(i) }
    ]
  })

  constructor(private date: DatePipe, private partners: PartnersService, private services: ServicesService, private groups: GroupsService, private sync: SynchronizationService) { }

  public name(i: PaymentReport): string {
    switch (i.Type) {
      case PaymentType.Partner:
        let partner = this.partners.get(i.PartnerID);
        return partner ? partner.Name : '';
      case PaymentType.Service:
        let service = this.services.get(i.PartnerID);
        return service ? service.Name : '';
      default: return '';
    }
  }

  public group(i: PaymentReport): string {
    switch (i.Type) {
      case PaymentType.Partner:
        return Multilingual.getText('Đối tác');
        
      case PaymentType.Service:
        let service = this.services.get(i.PartnerID);
        if (!service) return '';
        let group = this.groups.get(service.GroupID);
        return group ? group.Name : '';

      default: return '';
    }
  }

  public get sum() {
    return this.payments.matches.sum(i => i.Amount);
  }

  ngOnInit(): void {
    this.sync.when(PartnersService, ServicesService, GroupsService).commit(() => {
      this.payments.source = this.reports;
    });    
  }
}
